// ─────────────────────────────────────────
// App.js — the main router
// ─────────────────────────────────────────
// This controls which page the user sees.
// Think of it like a switchboard.
// Add new pages here as you build them.

import React, { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'

import Login from './pages/Login'
import Signup from './pages/Signup'
import Feed from './pages/Feed'
import Passport from './pages/Passport'
import Leaderboard from './pages/Leaderboard'
import LogRound from './pages/LogRound'
import CoursePage from './pages/CoursePage'
import Groups from './pages/Groups'
import CreateGroup from './pages/CreateGroup'
import GroupPage from './pages/GroupPage'
import ChatPage from './pages/ChatPage'
import UserPassport from './pages/UserPassport'
import InvitePage from './pages/InvitePage'
import ResetPassword from './pages/ResetPassword'

export default function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check if user is already logged in
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })

    // Listen for login/logout events
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => setSession(session)
    )

    return () => subscription.unsubscribe()
  }, [])

  if (loading) return <div style={styles.loading}>⛳</div>

  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes — no login needed */}
        <Route path="/login" element={!session ? <Login /> : <Navigate to="/" />} />
        <Route path="/signup" element={!session ? <Signup /> : <Navigate to="/" />} />
        <Route path="/invite/:username" element={!session ? <InvitePage /> : <Navigate to="/" />} />
        {/* Password reset — always accessible so the email link always works */}
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected routes — must be logged in */}
        <Route path="/" element={session ? <Feed session={session} /> : <Navigate to="/login" />} />
        <Route path="/passport" element={session ? <Passport session={session} /> : <Navigate to="/login" />} />
        <Route path="/leaderboard" element={session ? <Leaderboard session={session} /> : <Navigate to="/login" />} />
        <Route path="/log" element={session ? <LogRound session={session} /> : <Navigate to="/login" />} />
        <Route path="/course" element={session ? <CoursePage session={session} /> : <Navigate to="/login" />} />
        <Route path="/groups" element={session ? <Groups session={session} /> : <Navigate to="/login" />} />
        <Route path="/groups/create" element={session ? <CreateGroup session={session} /> : <Navigate to="/login" />} />
        <Route path="/groups/:groupId" element={session ? <GroupPage session={session} /> : <Navigate to="/login" />} />
        <Route path="/chat" element={session ? <ChatPage session={session} /> : <Navigate to="/login" />} />
        <Route path="/passport/:userId" element={session ? <UserPassport session={session} /> : <Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  )
}

const styles = {
  loading: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 48,
    background: '#0e1f13'
  }
}
